import axios from 'axios';

export const telegramConversationApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/telegram-conversation`,
    headers: {
        'Content-Type': 'application/json'
    }
})
